import React from "react";
import { useNavigate } from "react-router-dom";

export function AuthHeader() {
    const navigate = useNavigate();
    return (
        <div className="bg-gray-50 flex items-center p-10 pb-0 py-5 justify-start align-middle">
            <svg
                width={110}
                height={36}
                viewBox="0 0 110 36"
                className="cursor-pointer scale-100"
                onClick={() => navigate("/")}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ minWidth: 110, minHeight: 36 }}
            >
                <path
                    d="M16.9449 4.97852V0.82959H0V23.17H5.18917V15.0317H15.5675V10.8828H5.18917V4.97852H16.9449Z"
                    fill="#1F2937"
                />
                <path
                    d="M20.4579 23.17H25.6471V0.82959H20.4579V23.17Z"
                    fill="#1F2937"
                />
                <path
                    d="M46.4078 0.82959V14.3934L35.2606 0.82959H30.9684V23.17H36.0935V9.60618L47.2726 23.17H51.5329V0.82959H46.4078Z"
                    fill="#1F2937"
                />
                <path
                    d="M62.2513 18.9572L74.5195 4.18065V0.82959H55.6527V5.04236H67.6967L55.3965 19.819V23.17H75V18.9572H62.2513Z"
                    fill="#1F2937"
                />
            </svg>
        </div>
    );
}
